import AutoclickBehaviorAbstract from "../AutoclickBehaviorAbstract";

class AutoclickBehaviorCompletedDelay extends AutoclickBehaviorAbstract {
  onCompleted() {
    this.delayClickthrough(this.getBehaviorDelay());
  }
}

export default AutoclickBehaviorCompletedDelay;



// WEBPACK FOOTER //
// ./src/js/madlib/autoclick/behaviors/AutoclickBehaviorCompletedDelay.js